import { createContext, useContext, useEffect, useState, type ReactNode } from 'react';

/**
 * Derin route'ların (ör. `/air/reservations/:id`) breadcrumb yaprağını sayfanın
 * kendisinin netleştirmesi için ince bir context. Sayfa `useSetBreadcrumbLeaf('PNR
 * ABC123')` çağırır; unmount'ta otomatik temizlenir.
 */
interface BreadcrumbLeafContextValue {
  leaf: string | null;
  setLeaf: (label: string | null) => void;
}

const BreadcrumbLeafContext = createContext<BreadcrumbLeafContextValue>({
  leaf: null,
  setLeaf: () => {},
});

export function BreadcrumbLeafProvider({ children }: { children: ReactNode }) {
  const [leaf, setLeaf] = useState<string | null>(null);
  return (
    <BreadcrumbLeafContext.Provider value={{ leaf, setLeaf }}>{children}</BreadcrumbLeafContext.Provider>
  );
}

export function useBreadcrumbLeaf(): string | null {
  return useContext(BreadcrumbLeafContext).leaf;
}

/** Bir detay/akış sayfasından çağır — breadcrumb'ın son parçasını verilen metne
 *  ayarlar, bileşen kaldırıldığında geri alır. `null` geç → generic yaprağa dön. */
export function useSetBreadcrumbLeaf(label: string | null): void {
  const { setLeaf } = useContext(BreadcrumbLeafContext);
  useEffect(() => {
    setLeaf(label);
    return () => setLeaf(null);
  }, [label, setLeaf]);
}
